import { Injectable } from '@angular/core';
import { Theme, light, dark } from './theme';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  public active: Theme = light;
  private availableThemes: Theme[] = [light, dark];

  getAvailableThemes(): Theme[] {
    return this.availableThemes;
  }

  getActiveTheme(): Theme {
    return this.active;
  }

  isDarkTheme(): boolean {
    return this.active.name === dark.name;
  }

  setDarkTheme(): void {
    localStorage.setItem('activeTheme', 'dark');
    this.setActiveTheme(dark);
  }

  setLightTheme(): void {
    localStorage.setItem('activeTheme', 'light');
    this.setActiveTheme(light);
  }

  setActiveTheme(theme: Theme): void {
    this.active = theme;

    Object.keys(this.active.properties).forEach(property => {
      let property_val = '';
      switch (property) {
        case '--bg-accesibilidad':
          property_val = (window['DATA'].opleColor) ? ('--bg-' + window['DATA'].opleColor) : property;
          break;
        case '--bg-barra-contabilizadas':
          property_val = (window['DATA'].opleColor) ? ('--bg-barra-contabilizadas-' + window['DATA'].opleColor) : property;
          break;
        case '--bg-estadistica-nourbana':
          property_val = (window['DATA'].opleColor) ? ('--bg-estadistica-nourbana-' + window['DATA'].opleColor) : property;
          break;
      
        default:
          property_val = property;
          break;
      }
      document.documentElement.style.setProperty(
        property,
        this.active.properties[property_val]
      );
    });
  }
}

